// extracted by mini-css-extract-plugin
export default {"Toggle":"Toggle_Toggle__BIM3q","Label":"Toggle_Label__TsjB+","Title":"Toggle_Title__9tIMw","Slider":"Toggle_Slider__tVYJz"};